export class NopeReference {
  public key: string;

  public constructor(key: string) {
    this.key = key;
  }
}
